import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover';
import { Button } from './ui/button';
import { LuPanelRightClose, LuPanelLeftClose } from "react-icons/lu";
import { GoTrash } from "react-icons/go";
import { MdMoreHoriz } from "react-icons/md";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ setSelectedChat, setLoading }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [chats, setChats] = useState([]);
    const navigate = useNavigate();
    const sidebarRef = useRef(null); // Create a reference for the sidebar

    const toggleSidebar = () => setIsOpen(!isOpen);

    // Function to handle clicks outside the sidebar
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const deleteChat = async (chatId) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "api/chatbot/deleteChat",
                { thread_id: chatId },
                { headers: { "Content-Type": "application/json", "auth-token": token } }
            );

            if (response.data.success) {
                window.location.href = "/dashboard/chatbot";
            }
        } catch (error) {
            console.error("Error deleting chat:", error);
            setLoading(false);
        }
    };

    const fetchAllChats = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await axios.get(
                process.env.REACT_APP_API_URL + "api/chatbot/getAllChats",
                { headers: { "Content-Type": "application/json", "auth-token": token } }
            );

            if (response.data.success) {
                setChats(response.data.chats);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching chats:", error);
            setLoading(false);
        }
    };

    const handleSelect = (id) => {
        navigate(`/dashboard/chatbot?chat=${id}`);
        setSelectedChat(id);
    };

    useEffect(() => {
        fetchAllChats();
    }, []);

    return (
        <div className="w-full">
            <Button className="absolute !p-2 top-4 left-4" onClick={toggleSidebar}>
                {!isOpen && <LuPanelRightClose />}
            </Button>

            <motion.div
                ref={sidebarRef}
                initial={{ x: '-100%' }}
                animate={{ x: isOpen ? 0 : '-100%' }}
                transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                className="absolute top-0 left-0 h-full overflow-y-auto w-64 bg-[var(--accent)] text-white shadow-xl z-40 px-3 py-2"
            >
                <div className="mb-3 flex justify-between">
                    <div className="!p-2 text-xl cursor-pointer z-50" onClick={toggleSidebar}>
                        {isOpen && <LuPanelLeftClose />}
                    </div>
                    <img
                        onClick={() => (window.location.href = "/dashboard/chatbot")}
                        className="invert cursor-pointer"
                        src="/images/chat.svg"
                        alt=""
                    />
                </div>
                <h2 className="text-xl font-bold mb-4">Chat History</h2>
                {/* <Button onClick={handleDeleteChat}  className="mb-4">Clear Chats</Button> */}
                <ul className="space-y-1">
                    {chats.map((chat) => (
                        <li
                            key={chat.id}
                            onClick={() => handleSelect(chat.thread_id)}
                            className="flex cursor-pointer justify-between items-center hover:bg-gray-700 rounded"
                        >
                            <p className="line-clamp-1 px-2 text-sm">{chat.chat_title}</p>
                            <Popover>
                                <PopoverTrigger asChild>
                                    <Button variant="ghost" className="p-1">
                                        <MdMoreHoriz />
                                    </Button>
                                </PopoverTrigger>
                                <PopoverContent className="p-2 text-sm">
                                    <Button
                                        variant="destructive"
                                        onClick={() => deleteChat(chat.thread_id)}
                                        className="flex items-center gap-2"
                                    >
                                        <GoTrash /> Delete Chat
                                    </Button>
                                </PopoverContent>
                            </Popover>
                        </li>
                    ))}
                </ul>
            </motion.div>
        </div>
    );
};

export default Sidebar;
